import Cookie from 'js-cookie'
import jwt_decode from 'jwt-decode'
import Router from 'next/router'
import { removerCarrinho } from 'src/contexto/hooks/useCarrinho'
import useLinxMeta from 'src/util/hooks/useLinxMeta'
import { removeChoosePickUp } from 'src/util/inStorePickUp'
import api from './api'

export const USER_LOCAL_KEY = process.env.REACT_APP_STORAGE_KEY + 'user'
const getDomainName = () =>
  window.location.hostname.includes('localhost') ? 'localhost' : '.gazin.com.br'
// eslint-disable-next-line react-hooks/rules-of-hooks
const { setLinxUser, removeLinxUser } = useLinxMeta()

const setUser = (data) =>
  Cookie.set(USER_LOCAL_KEY, JSON.stringify(data), { domain: getDomainName() })
const getUser = () => JSON.parse(Cookie.get(USER_LOCAL_KEY) ?? null)
const removeUser = () =>
  Cookie.remove(USER_LOCAL_KEY, { domain: getDomainName() })

export const autenticado = () => {
  try {
    const data = getUser()

    if (data !== null && data.access_token != null) {
      return verificarToken(data.access_token)
    }

    return false
  } catch (error) {
    Router.push('/cookie')
  }
}

export const verificarToken = (token) => {
  try {
    const decoded = jwt_decode(token)

    const expireAt = new Date(decoded.exp * 1000)
    const expired = expireAt < Date.now()

    if (expired) {
      removeUser()
      removeLinxUser()
      removerCarrinho()
    }

    return !expired
  } catch (error) {
    Router.push('/cookie')
  }
}

export function getUserDataCookie() {
  try {
    return getUser()
  } catch (error) {
    Router.push('/cookie')
  }
}

export const getNome = () => {
  try {
    const data = getUser()
    if (data != null && data.user_name != null) return data.user_name
    return ''
  } catch (error) {
    Router.push('/cookie')
  }
}

export const getEmail = async () => {
  await api
    .get('/canais/consumidores', {
      headers: {
        authorization: 'Bearer ' + getToken(),
      },
    })
    .then((response) => {
      return response.data.email
    })
    .catch(() => {
      return null
    })
}

export const getToken = () => {
  try {
    const data = getUser()
    if (data != null && data.access_token != null) return data.access_token
  } catch (error) {
    Router.push('/cookie')
  }
}

export const login = (data) => {
  try {
    data['timestamp_create'] = new Date().getTime()
    setUser(data)
    setLinxUser()
  } catch (error) {
    Router.push('/cookie')
  }
}

export const logout = () => {
  try {
    removeChoosePickUp()
    removeUser()
    removeLinxUser()
    removerCarrinho()
  } catch (error) {
    Router.push('/cookie')
  }
}

/**
 * Dispara redefinição de senha para API e armazena no local
 * a flag senhaRedefinida para ser consumida pela tela de login
 */
export const redefinirSenha = async (data) => {
  const response = await api.post('/canais/resetar-senha', data)

  // Define localmente uma flag para a página de login consumir
  // e mostrar o toast
  try {
    localStorage.setItem('senhaRedefinida', true)
    return response
  } catch (error) {
    Router.push('/cookie')
  }
}

/** Consome a flag de senha redefinida para efeitos de mostrar o toast */
export const senhaRedefinida = () => {
  try {
    const reset = JSON.parse(localStorage.getItem('senhaRedefinida'))
    if (reset) {
      localStorage.setItem('senhaRedefinida', false)
    }
    return reset
  } catch (error) {
    Router.push('/cookie')
  }
}

export const getDadosUsuario = async () => {
  if (getToken()) {
    return await api.get('/canais/consumidores', {
      headers: {
        authorization: 'Bearer ' + getToken(),
      },
    })
  }
}
